import { Module } from '@nestjs/common';
import { RmToleranceController } from './rm-tolerance.controller';
import { RmToleranceService } from './rm-tolerance.service';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { RmTolerance } from './rm-tolerance.entity';
import { RmToleranceAdapter } from './dto/rm-tolerance.adapter';
import { LogsService } from '@gtpl/shared-services/user-logs';
@Module({
  imports:[
    TypeOrmModule.forFeature([RmTolerance]),
  ],
  controllers: [RmToleranceController],
  providers: [RmToleranceService,ApplicationExceptionHandler,RmToleranceAdapter,LogsService]
})
export class RmToleranceModule {}
